const passkey_sign_in = {
    setup_page: {
        title: 'ทำให้การลงชื่อเข้าใช้ของคุณง่ายขึ้น',
        subtitle: 'สร้างกุญแจผ่าน',
        description: 'ลงทะเบียนกุญแจผ่านของคุณด้วยไบโอเมตริกบนอุปกรณ์ กุญแจความปลอดภัยอย่าง YubiKey หรือวิธีอื่นที่มีให้ใช้',
    },
    trigger_conditional_ui_failed: 'ไม่สามารถเรียกใช้การกรอกอัตโนมัติด้วย passkey ได้',
};
export default Object.freeze(passkey_sign_in);
